import { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Skeleton, Alert, Typography } from "@mui/material";
import { Delete, Edit, EventNote } from "@mui/icons-material";
import { modalEdit, modalConfirm } from "../../features/modal/modalSlice";
import { loadNextPage } from "../../features/teachers/teachersSlice";
import { Pagination } from "../Tools";

const numberOfPages = (total, size) => Math.ceil(total/size);

const Content = () => {
    const { isLoading } = useSelector(state => state.progress)
    const { currentPage, rows, size, teachers } = useSelector(state => state.teachers)
    const dispatch = useDispatch();
    const [page, setPage] = useState(currentPage);
    const [rowsPerPage, setRowsPerPage] = useState(size);
    const pages = useMemo(() => numberOfPages(rows, rowsPerPage), [rows, rowsPerPage])
    const handleChangePage = (event, next) => {
        setPage(next);
        dispatch(loadNextPage({ page: next+1, size: rowsPerPage }))
    }
    const handleChangeRowsPerPage = (event) => {
        let size = +event.target.value;
        setRowsPerPage(size);
        setPage(0);
        dispatch(loadNextPage({ page: 1, size }))
    }
    const genders = {H: 'HOMBRE', M: "MUJER"}
    const navigate = useNavigate();
    const headers = ['Código', 'Nombre', 'Sexo', 'Departamento', '','','']
    return(
        isLoading ? <Skeleton animation='wave' height={200} /> : rows ? (
            <TableContainer> <br />
                <Alert severity="success" >Resultados <b>{rows}</b></Alert> <br />
                <Typography variant="caption">Página <b>{page + 1}</b> de <b>{pages}</b></Typography>
                <Table>
                    <TableHead>
                        <TableRow>
                            { headers.map((h ,i) => <TableCell key={i}>{h}</TableCell>) }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { teachers.map(({id, codigo, nombre, genero, departamento}, i) => (
                            <TableRow key={i}>
                                <TableCell>{codigo}</TableCell>
                                <TableCell>{nombre}</TableCell>
                                <TableCell>{genders[genero]}</TableCell>
                                <TableCell>{departamento}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => navigate(`/profesores/${id}`)} color="info">
                                        <EventNote />
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    <IconButton onClick={() => dispatch(modalEdit(id))}  color="primary">
                                        <Edit />
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    <IconButton onClick={() => dispatch(modalConfirm({id, item: nombre}))}  color="secondary">
                                        <Delete />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )) }
                    </TableBody>
                    <Pagination 
                        rows={rows}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Table>
            </TableContainer>
        ) : <Alert severity="warning">No se encontraron resultados</Alert>
    )
}

export default Content;